import { RequireAtLeastOne, UnboxCollection } from '@skylab-shared/types';
import { Calc, MidpointRounding } from '@skylab-shared/utils';
import { CalculatedDocument, DocumentAdjustmentCalculator, DocumentCalculator, DocumentItemForDocument } from '@skylab/calculations/document';

type MarginItem = RequireAtLeastOne<DocumentItemForDocument, 'grossValue'> & { cost: number; exchangeRate: number; };

type VatTableItem = UnboxCollection<CalculatedDocument['vatTableItems']> & { cost: number; };

export class SaleDocumentMarginCalculator extends DocumentCalculator<MarginItem> {
    protected sumItems(items: MarginItem[], precision: number): VatTableItem {
        const [{ vatRate, vatRateId, exchangeRate }] = items;
        const grossValue = Calc.round(items.reduce((sum, { grossValue }) => sum + grossValue, 0), precision, MidpointRounding.AwayFromZero);
        const cost = Calc.round(items.reduce((sum, { cost }) => sum + cost, 0), precision, MidpointRounding.AwayFromZero);

        const costInCurrency = Calc.round(cost / (exchangeRate || 1), precision, MidpointRounding.AwayFromZero);
        const baseForVat = Calc.round(grossValue - costInCurrency, precision, MidpointRounding.AwayFromZero);

        const vatValue = Calc.round(baseForVat * (vatRate / (1 + vatRate)), precision, MidpointRounding.AwayFromZero);
        const netValue = Calc.round(grossValue - vatValue, precision, MidpointRounding.AwayFromZero);
        return {
            vatRate,
            vatRateId,
            cost,
            netValue,
            vatValue,
            grossValue
        };
    }
}

export class SaleDocumentAdjustmentMarginCalculator extends DocumentAdjustmentCalculator {
    protected get documentCalculator(): DocumentCalculator {
        return new SaleDocumentMarginCalculator();
    }
}
